import Pusher from "pusher-js";
import EchoObservable from "laravel-echo-observable";
//

class Socket extends EchoObservable {
  messageCreated$(userId) {
    return this.private(`users.${userId}`).listen(".message.created");
  }
}

const { env } = window.SERVER;

export default new Socket({
  key: env.PUSHER_KEY,
  authEndpoint: env.PUSHER_AUTH,
  cluster: "ap1",
  encrypted: true,
});
